module.exports = __webpack_public_path__ + "assets/img/34a0-il.svg";